<!-- Tasks Header -->
<mat-toolbar color="accent">
  <span role="heading" class="mat-title">Steps</span>
  <span class="spacer"></span>
  <!-- Tasks List Actions -->
  <span role="toolbar">
    <button mat-raised-button id="steps-add" (click)="addStep()">
      <mat-icon>add_task</mat-icon> New Step
    </button>
  </span>
</mat-toolbar>
<!-- Tasks List -->
<mat-list cdkDropList id="subtasks-list" (cdkDropListDropped)="drop($event)" [cdkDropListData]="steps$|async" [cdkDropListConnectedTo]="['tasks-list']">
  <app-tasks-item cdkDrag *ngFor="let step of steps$ | async; index as i" [tabindex]="i" [task]="step" [cdkDragData]="step" (click)="onSelect(step)" (deleted)="onDeleted(step)" (undeleted)="onUndeleted(step)" (completed)="onCompleted(step)">
  </app-tasks-item>
</mat-list>
